import { AType, EType, summon } from "@silversea-ssc/functional-support"
import { CheckoutProcessId } from "../checkout-process-id"
import { PriceRequestV2, SuitePayment } from "../price"
import { SuiteNumber } from "../suite-number"
import { CheckoutFlowType } from "../checkout-flow-type"

export const MainGuest = summon((F) =>
    F.interface(
        {
            title: F.string(),
            firstName: F.string(),
            lastName: F.string(),
            email: F.string(),
            phone: F.string(),
        },
        "MainGuest",
    ),
)
export type MainGuest = AType<typeof MainGuest>
export type MainGuestEncoded = EType<typeof MainGuest>

export const OtherGuest = summon((F) =>
    F.interface(
        {
            title: F.string(),
            firstName: F.string(),
            lastName: F.string(),
        },
        "OtherGuest",
    ),
)
export type OtherGuest = AType<typeof OtherGuest>
export type OtherGuestEncoded = EType<typeof OtherGuest>

export const ValidateCheckoutRequest = summon((F) =>
    F.interface(
        {
            id: CheckoutProcessId(F),
            trackingId: F.string(),
            captchaSolution: F.string(),
            auid: F.string(),
            price: PriceRequestV2(F),
            suiteNumber: SuiteNumber(F),
            mainGuest: MainGuest(F),
            otherGuests: F.array(OtherGuest(F)),
            suitePayment: SuitePayment(F),
            flowType: CheckoutFlowType(F),
        },
        "ValidateCheckoutRequest",
    ),
)
export type ValidateCheckoutRequest = AType<typeof ValidateCheckoutRequest>
